"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.spinner = exports.button = exports.custom = exports.dialog = void 0;
const defaults_1 = require("./defaults");
/**
 * Dialog Box HTML to render for terms & Conditions
 * @param {object} options
 * @return string HTML
 */
const dialog = (options) => `
<div class="gcpt">
	<article class="gcpt-container">
		<header class="gcpt-container-header">
			<h3 class="gcpt-container-title">
				<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24" aria-hidden="true">
					<path fill="none" d="M0 0h24v24H0z" />
					<path fill="currentColor" d="M14 9V4H5v16h6.056c.328.417.724.785 1.18 1.085l1.39.915H3.993A.993.993 0 0 1 3 21.008V2.992C3 2.455 3.449 2 4.002 2h10.995L21 8v1h-7zm-2 2h9v5.949c0 .99-.501 1.916-1.336 2.465L16.5 21.498l-3.164-2.084A2.953 2.953 0 0 1 12 16.95V11zm2 5.949c0 .316.162.614.436.795l2.064 1.36 2.064-1.36a.954.954 0 0 0 .436-.795V13h-5v3.949z" />
				</svg>
				${defaults_1.TITLE}
			</h3>
		</header>
		<section class="gcpt-container-body rtf">
			${options.content}
		</section>
		<footer class="gcpt-container-footer">
    ${(0, exports.button)({ label: defaults_1.BTN_REJECT, id: defaults_1.BTN_REJECT_ID, classes: 'is-ghost' })}
    ${(0, exports.button)({ label: defaults_1.BTN_ACCEPT, id: defaults_1.BTN_ACCEPT_ID, classes: 'is-primary' })}
		</footer>
	</article>
</div>
`;
exports.dialog = dialog;
/**
 * Plain Terms and Condition HTML
 * @param {object} options
 * @return string HTML
 */
const custom = (options) => `
			${options.content}
`;
exports.custom = custom;
/**
 * HTML Button tag string
 * @param {object} options
 * @return string HTML
 */
const button = (options) => `<button type="button" class="button ${options.classes}" id="${options.id}">${options.label}</button>`;
exports.button = button;
/**
 * SVG for spinner
 * @return string HTML
 */
const spinner = () => `
<svg width="20" height="20" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><style>.spinner_P7sC{transform-origin:center;animation:spinner_svv2 .75s infinite linear}@keyframes spinner_svv2{100%{transform:rotate(360deg)}}</style><path fill="#fff" d="M10.14,1.16a11,11,0,0,0-9,8.92A1.59,1.59,0,0,0,2.46,12,1.52,1.52,0,0,0,4.11,10.7a8,8,0,0,1,6.66-6.61A1.42,1.42,0,0,0,12,2.69h0A1.57,1.57,0,0,0,10.14,1.16Z" class="spinner_P7sC"/></svg>`;
exports.spinner = spinner;
